import React from 'react';
import { BackTop } from 'antd';

const BackToTop = () => <BackTop className="back-to-top" />;

export {
    BackToTop as default,
};
